import { BlockMobile as Block } from '@alfa-bank/site-block/mobile';
import { TextMobile as Text } from '@alfa-bank/site-text-v2/mobile';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { IDeps, TWarranty } from './models';
import { Warranty as Component } from './warranty';
import styles from './styles/mobile.css';

export const WarrantyMobile = createWidget<IDeps, TWarranty>({
    Block,
    isMobile: true,
    styles,
    Text,
})(Component);
